import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  decor?: string;
  text: string;
};

const Wrap = styled.div`
  && {
    display: flex;
    .main {
      display: flex;
      align-items: center;
      .rectangle {
        width: 13px;
        height: 59px;
        background: #000000;
        border-top-left-radius: 10px;
        margin-right: 20px;
      }
    }
    .extra {
      display: flex;
      align-items: center;
    }
  }
`;

const Rectangle: FC<Props> = ({ children, decor, text }) => {
  return (
    <Wrap className={decor}>
      <div className="main">
        <div className="rectangle" />
        <p className="largeBoldFont mb-0">{text}</p>
      </div>
      <div className="extra">{children}</div>
    </Wrap>
  );
};

export default Rectangle;
